<template>
    <div>
        <div class="container container-small py-4">
            <Heading class="py-4" :title="$t('reset_password_title')" :routeName="'vignette'"></Heading>
            <template v-if="!message.length">
                <div class="form-group">
                    <label>{{ $t('label_password') }}</label>
                    <input type="password" class="form-control" v-model="password" :placeholder="$t('password')">
                </div>
                <div class="form-group">
                    <label>{{ $t('label_confirm_password') }}</label>
                    <input type="password" class="form-control" v-model="password_confirmation" :placeholder="$t('password_confirm')">
                </div>
                <button class="btn btn-purple mt-3 w-100" @click="save()">{{ $t('btn_save') }}</button>
            </template>
            <template v-if="message.length">
                <div class="alert alert-success text-center">
                    {{message}}
                </div>
                <div class="text-center">
                    {{ $t('return_to_login_1') }}
                    <router-link class="custom-link" :to="{name: 'login'}">
                        {{ $t('return_to_login_2') }}
                    </router-link>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Heading from './../snippets/Heading.vue'

export default {
    name: 'ResetPassword',
    components: {
        Heading
    },
    props: {
        token: {
            type: String,
            default: null
        }
    },
    data: function() {
        return {
            password: '',
            password_confirmation: '',
            loading: false,
            message: ''
        }
    },
    methods: {
        save() {
            this.loading = true;

            if(!this.token) {
                return false;
            }

            this.$axios.post('reset-password-update/' + this.token, {
                password: this.password,
                password_confirmation: this.password_confirmation
            }).then(response => {
                this.message = response.data.message;
                this.loading = false;
            }).catch(err => {
                this.loading = false;
                this.$dialog.alert({
                    'message': err.response.data.error.error_msg,
                    'confirmButtonText': this.$t('btn_i_understand')
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>

input[type=checkbox] {
    margin-top: 15px;
}

p {
    margin-bottom: 0;
    margin-top:15px;
}



$lightgrey: lightgrey;
$green: #59af54;

</style>
